import React from "react";
import * as User from "./models/User";

export const UserContext = React.createContext<User.AdminUser>(
  User.anonymous()
);
export const UserProvider = UserContext.Provider;
